<div class="style-toggle-wrap">
  <label class="toggle-title">Interaction Accent</label>

  <div class="form-check form-switch toggle-switch-wrap">
    <input
      id="interactionAccentToggle"
      class="form-check-input"
      type="checkbox"
      [checked]="isSecondaryMode()"
      (change)="onModeChange($any($event.target).checked)"
    >
    <label class="form-check-label" for="interactionAccentToggle">
      {{ mode === 'secondary' ? 'Secondary mode' : 'Primary mode' }}
    </label>
  </div>
  <div class="toggle-helper-text">
    Affects focus rings, active states, tabs, dropdown emphasis, and interactive accent color across the app.
  </div>

  <button type="button" class="reset-btn" (click)="resetToDefault()">
    Reset to defaults
  </button>

  <hr class="divider">

  <label class="toggle-title">Legacy Compatibility</label>
  <div class="form-check form-switch toggle-switch-wrap">
    <input
      id="legacyCompatToggle"
      class="form-check-input"
      type="checkbox"
      [checked]="legacyCompatEnabled"
      (change)="onLegacyModeChange($any($event.target).checked)"
    >
    <label class="form-check-label" for="legacyCompatToggle">
      {{ legacyCompatEnabled ? 'Enabled' : 'Disabled' }}
    </label>
  </div>
  <div class="toggle-helper-text">
    Master switch for all legacy compatibility styles below.
  </div>

  <div class="legacy-toggle-list" *ngIf="legacyCompatEnabled">
    <div class="legacy-toggle-item" *ngFor="let toggle of legacyToggleDefinitions">
      <div class="form-check form-switch toggle-switch-wrap">
        <input
          class="form-check-input"
          type="checkbox"
          [id]="'legacy-toggle-' + toggle.key"
          [checked]="legacyToggles[toggle.key]"
          (change)="onLegacyToggleChange(toggle.key, $any($event.target).checked)"
        >
        <label class="form-check-label" [for]="'legacy-toggle-' + toggle.key">
          {{ toggle.label }}
        </label>
      </div>
      <div class="toggle-helper-text">{{ toggle.helperText }}</div>
    </div>
  </div>
</div>
